export default __webpack_public_path__ + "static/jason-lap-6ee711f28831ec2533eefc6c2fefb2df.png";